export default {
  methods: {
    onGetProvince () {
      if (this.provinces.length <= 0) {
        this.loading = true
        request.loading('getProvinces').then(({data}) => {
          this.provinces = data
          this.loading = false
        })
      }
    },
    onGetCities (status) {
      if (status) {
        if (this.cities.length <= 0) {
          this.loading = true
          if (this.search.provinceid) {
            request.loading('getCities', {pid: this.search.provinceid}).then(({data}) => {
              this.cities = data
              this.loading = false
            })
          } else {
            request.loading('queryCitymap', {keyword: '', type: 1}).then(({data}) => {
              this.cities = data
              this.loading = false
            })
          }
        }
      }
    },
    onGetAreaes (status) {
      if (status) {
        if (this.areaes.length <= 0) {
          this.loading = true
          if (this.search.cityid) {
            request.loading('getDistricts', {pid: this.search.cityid}).then(({data}) => {
              this.areaes = data
              this.loading = false
            })
          } else {
            request.loading('queryCitymap', {keyword: '', type: 2}).then(({data}) => {
              this.areaes = data
              this.loading = false
            })
          }
        }
      }
    },
    onChangeProvince (value) {
      this.cities = []
      this.areaes = []
      this.search.cityid = null
      this.search.areaid = null
    },
    onChangeCity (value) {
      this.areaes = []
      this.search.areaid = null
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/market/market.mixins.js